

import type { ComponentType } from "react";
import styles from "../DeckorateModule.module.css";

interface RibCardProps {
  readonly icon: ComponentType;
  readonly title: string;
  readonly description: string;
  readonly shortcut?: string;
  readonly wide?: boolean;
  /** When provided the card is actionable; when omitted it is a placeholder. */
  readonly onClick?: () => void;
}

export function RibCard({
  icon: Icon,
  title,
  description,
  shortcut,
  wide,
  onClick,
}: Readonly<RibCardProps>) {
  const soon = onClick === undefined;
  const className = [
    styles.rib,
    wide ? styles.ribWide : "",
    soon ? styles.ribSoon : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      disabled={soon}
      aria-disabled={soon || undefined}
    >
      <span className={styles.ribIcon} aria-hidden="true">
        <Icon />
      </span>
      <span className={styles.ribText}>
        <span className={styles.ribTitleRow}>
          <span className={styles.ribTitle}>{title}</span>
          {shortcut && !wide && <span className={styles.kbd}>{shortcut}</span>}
          {soon && <span className={styles.soonTag}>Soon</span>}
        </span>
        <span className={styles.ribDesc}>{description}</span>
      </span>
      {/* A full-width card has room to dock its shortcut chip at the far end,
          as the mockup's "All actions" row does, instead of inline after the
          title where a two-column card has to keep it. */}
      {shortcut && wide && <span className={styles.kbd}>{shortcut}</span>}
    </button>
  );
}
